export const USER_NAME = 'USER_NAME'
export const USER_TOKEN = 'USER_TOKEN'
export const USER_TOKEN_EXPIRES_IN = 'USER_TOKEN_EXPIRES_IN'
export const USER_SUBTITLE = 'USER_SUBTITLE'
export const USER_ROLE = 'USER_ROLE'

export const CAMPAIGN_MANAGER = 'campaign-manager'
export const PROVINCIAL_CAMPAIGNMANAGER = 'p-campaign-manager'